import { SOV_PIE_CHART_PALETTE } from '../../utils/sovPalette';
import { SELECTED_BRAND_COLOR } from '../../utils/utils';

/**
 * Kolory marek dla całego raportu — jedna mapa, budowana raz z rankingu Share of Voice.
 *
 * Wcześniej każda sekcja liczyła kolor z pozycji na WŁASNEJ liście (SoV, widoczność, heatmapa), więc
 * ta sama marka bywała gdzie indziej innego koloru. Kolejność SoV jest tu kanoniczna, bo to ona
 * ustala kolory wycinków wykresu kołowego.
 */
export const buildBrandColors = (
  brands: Array<{ brand: string; isTracked: boolean }>
): Map<string, string> => {
  const colors = new Map<string, string>();

  brands.forEach((entry, index) => {
    colors.set(
      entry.brand,
      entry.isTracked
        ? SELECTED_BRAND_COLOR
        : SOV_PIE_CHART_PALETTE[index % SOV_PIE_CHART_PALETTE.length]
    );
  });

  return colors;
};

/** Kolor marki z mapy; marka spoza rankingu SoV dostaje kolejny kolor palety. */
export const brandColorOf = (
  colors: Map<string, string>,
  brand: string,
  isTracked: boolean,
  fallbackIndex: number
): string => {
  if (isTracked) {
    return SELECTED_BRAND_COLOR;
  }

  return (
    colors.get(brand) ??
    SOV_PIE_CHART_PALETTE[(colors.size + fallbackIndex) % SOV_PIE_CHART_PALETTE.length]
  );
};
